const optionToggleBtns = document.querySelectorAll('[data-options]');
for(let i = 0; i < optionToggleBtns.length; i++) {
	optionToggleBtns[i].onclick = function() {
		
		const sameGroupOptions = this.closest('dd').querySelectorAll('.options[data-group='+this.getAttribute('data-group')+']');
		for(let j = 0; j < sameGroupOptions.length; j++) {
			sameGroupOptions[j].classList.remove('open');
			const targetOptionFields = sameGroupOptions[j].querySelectorAll('input,textarea');
			for(let k = 0; k < targetOptionFields.length; k++) {
				
				if(targetOptionFields[k].getAttribute('type') == 'radio') {
					targetOptionFields[k].checked = false;
				} else {
					targetOptionFields[k].value = '';
				}
			}
		}
		
		const targetOptions = this.closest('dd').querySelector('.options');
		const targetOptionFields = targetOptions.querySelectorAll('input,textarea');
		if(this.getAttribute('data-options')=='open') {
			targetOptions.classList.add('open');
		} else if(this.getAttribute('data-options')=='close') {
			targetOptions.classList.remove('open');
			for(let j = 0; j < targetOptionFields.length; j++) {
				
				if(targetOptionFields[j].getAttribute('type') == 'radio') {
					targetOptionFields[j].checked = false;
				} else {
					targetOptionFields[j].value = '';
				}
			}
		}
	}
}

const optionOpenBtns = document.querySelectorAll('[data-open]');
for(let i = 0; i < optionOpenBtns.length; i++) {
	optionOpenBtns[i].onclick = function() {
		const sameGroupOptions = this.closest('dd').querySelectorAll('.options[data-group='+this.getAttribute('data-group')+']');
		for(let j = 0; j < sameGroupOptions.length; j++) {
			sameGroupOptions[j].classList.remove('open');
			const targetOptionFields = sameGroupOptions[j].querySelectorAll('input,textarea');
			for(let k = 0; k < targetOptionFields.length; k++) {
				
				if(targetOptionFields[k].getAttribute('type') == 'radio') {
					targetOptionFields[k].checked = false;
				} else {
					targetOptionFields[k].value = '';
				}
			}
		}
		
		if(this.getAttribute('data-open')) {
			this.closest('dd').querySelector('.options[data-name='+this.getAttribute('data-open')+']').classList.add('open');
			//this.closest('dd').querySelector('.options[data-name='+this.getAttribute('data-open')+'] input').checked = true;
		}
	}
}

document.getElementById('contactForm').addEventListener('submit',function(event){
    
    // 既出のエラーメッセージを削除
    const errMsgs = this.querySelectorAll('.errMsg');
    for(let i = 0; i < errMsgs.length; i++) {
      errMsgs[i].remove();
    }
	
	if(formName) {
		
			// フォームデータを作成
			const formData = new FormData(this);
			formData.append("formName", formName);

			fetch("https://contact.luvonical.com/sender.php", { method: "POST", body: formData })
				.then((res)=>{
					return( res.json() );
				})
				.then((json)=>{
					// 通信が成功した際の処理
					if(!json['status']) {
						const errs = json['error'];
						for (let key in errs) {
							const errField = this.querySelectorAll('[name='+key+']');
							const errMsg = document.createElement("p");
							errMsg.classList.add('errMsg');
							errMsg.innerHTML = errs[key];
							if(errField[errField.length-1].parentNode.classList.contains('labelBtn')) {
								errField[errField.length-1].parentNode.parentNode.insertBefore(errMsg, errField[errField.length-1].nextElementSibling);
							} else {
								errField[errField.length-1].parentNode.insertBefore(errMsg, errField[errField.length-1].nextElementSibling);
							}
						}
						window.scrollTo(0, 0);
					} else {
						const thkMsg = document.createElement("p");
						thkMsg.classList.add('tCenter');
						thkMsg.innerHTML = 'この度はLUVONICAL flower worksにお問い合わせいただきましてありがとうございました。<br>お問い合わせを受け付けいたしました。<br>3営業日以内に、担当者よりご連絡いたしますので今しばらくお待ちくださいませ。';
						this.parentNode.insertBefore(thkMsg, this.nextElementSibling);
						this.remove();
					}
				});

			// イベント伝搬の停止
			event.stopPropagation();
			// イベントキャンセル
			event.preventDefault();
	}
});